export enum Airflow {
    OUTDOOR,
    SUPPLY,
    EXTRACT,
    EXHAUST,
    NONE
}
